import { render, staticRenderFns } from "./ToDoClick.vue?vue&type=template&id=07160ec2&scoped=true&"
import script from "./ToDoClick.vue?vue&type=script&lang=js&"
export * from "./ToDoClick.vue?vue&type=script&lang=js&"
import style0 from "./ToDoClick.vue?vue&type=style&index=0&id=07160ec2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07160ec2",
  null
  
)

export default component.exports